<template>
    <div class="member-manage">
        <div class="page-title">
            <span class="title">成员管理</span>
            <veui-button
                ui="primary xl"
                @click="addLawyer"
            >
                添加律师
            </veui-button>
        </div>
        <div class="table-top">
            <p class="count">共 {{ count }} 名用户</p>
        </div>
        <veui-table
            class="member-list-table"
            ui="m"
            :data="tableData"
            key-field="uk"
            :loading="loading"
        >
            <veui-table-column
                field="personalAvatar"
                title="律师信息"
            >
                <template #default="{personalAvatar, name}">
                    <div class="avatar-name-cell">
                        <img class="member-avatar" :src="personalAvatar"/>
                        <span class="member-name">{{ name }}</span>
                    </div>
                </template>
            </veui-table-column>
            <veui-table-column
                field="registerDomain"
                title="擅长领域"
                width="370"
            />
            <veui-table-column
                field="interveneYears"
                title="执业年限"
                width="100"
            />
            <veui-table-column
                field="registerId"
                title="执业资格证号"
                width="200"
            />
            <veui-table-column
                field="infoStatus"
                title="审核状态"
                width="120"
            >
                <template #default="{infoStatus}">
                    <span
                        :style="{color: infoStatusMap[infoStatus] ? infoStatusMap[infoStatus].color : '#333'}"
                    >
                        {{ infoStatusMap[infoStatus] ? infoStatusMap[infoStatus].text : '审核异常' }}
                    </span>
                </template>
            </veui-table-column>
            <veui-table-column
                field="operation"
                title="操作"
                fixed="right"
                align="center"
                width="100"
            >
                <template #default="{uk, name, personalAvatar}">
                    <a @click="openUnbindConfirm(uk, name, personalAvatar)">解绑</a>
                </template>
            </veui-table-column>
            <template #no-data>
                <div v-if="!loading" class="blank">
                    <div class="icon"></div>
                    <div class="text">暂无成员</div>
                </div>
            </template>
        </veui-table>
        <veui-pagination
            v-if="tableData.length"
            class="pagination"
            :page="pn"
            :page-size="rn"
            :total="count"
            @redirect="pageChange"
        />
        <!-- 添加律师 弹窗 -->
        <veui-dialog
            overlay-class="add-lawyer-modal"
            ui="auto"
            title="添加律师"
            :open.sync="isModalShow"
        >
            <veui-form
                ref="form"
                :data="formData"
            >
                <veui-field
                    name="name"
                    label="姓名"
                    :rules="[{name: 'required', value: true}]"
                >
                    <veui-input
                        v-model="formData.name"
                        placeholder="请输入律师姓名"
                        autocomplete="off"
                    />
                </veui-field>
                <veui-field
                    name="phone"
                    label="律临执业手机号"
                    :rules="[{name: 'required', value: true}]"
                >
                    <veui-input
                        v-model="formData.phone"
                        placeholder="请输入律临执业手机号"
                        autocomplete="off"
                    />
                </veui-field>
            </veui-form>
            <div class="tips">律师添加成功3小时后，即可在【团队成员】中上线并展示该律师于律所主页中</div>
            <template #foot>
                <veui-button
                    ui="primary"
                    :loading="addLoading"
                    @click="handleSubmitLawyer"
                >
                    添加
                </veui-button>
                <veui-button @click="handleModalClose">取消</veui-button>
            </template>
        </veui-dialog>
        <!-- 解绑 二次确认 -->
        <veui-dialog
            overlay-class="unband-confirm"
            title="确认解绑吗？"
            :loading="unbandLoading"
            :open.sync="isConfirmShow"
        >
            <div v-if="isUnBind">
                <p class="confirm-text">解绑后该成员被授权的律享权益、内容认领权益、线索认领权益将被取消授权</p>
            </div>
            <div v-else>
                <p class="confirm-text">当前成员存在效果权益记录，请指定新成员换绑跟进</p>
                <div
                    v-if="isHasClue"
                    class="lawyer-box"
                >
                    <p class="confirm-text">已认领线索更换至：</p>
                    <veui-select
                        v-model="newLawyerName"
                        placeholder="选择律师"
                        class="lawyer-search"
                    >
                        <veui-option
                            v-for="(item,index) in clueTransList"
                            :key="index"
                            :value="item.name"
                            :label="item.name"
                        />
                    </veui-select>
                </div>
                <div
                    v-if="isHasContent"
                    class="lawyer-box"
                >
                    <p class="confirm-text">已认领内容更换至：</p>
                    <veui-select
                        v-model="contentLawyerName"
                        placeholder="选择律师"
                        class="lawyer-search"
                    >
                        <veui-option
                            v-for="(item,index) in contentTransList"
                            :key="index"
                            :value="item.name"
                            :label="item.name"
                        />
                    </veui-select>
                </div>
                <p class="confirm-tip">解绑后该成员如被授权的内容认领权益、成员推广权益将取消授权并返还已使用额度至律所</p>
            </div>
            <template #foot>
                <div class="btn-box">
                    <a class="btn-item" @click="hideConfirm">取消</a>
                    <a class="btn-item confirm" @click="confirmUnband">确认</a>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 律临-成员管理
 * @author <lice02@baidu.com>
*/
import {Button, Table, Column, Pagination, Dialog, Form, Field, Input, Select, Option} from 'veui';
import isBoolean from 'lodash/isBoolean';
import {mapState} from 'vuex';

const url = {
    getBusinessMember: '/bp/api/business/getlawyerlist',
    addBusinessMember: '/bp/api/business/addlawyer',
    delBusinessMember: '/bp/api/business/releaselawyer',
    checkChangeMember: '/bp/api/business/checkchangemember'
};

export default {
    components: {
        'veui-button': Button,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-dialog': Dialog,
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-select': Select,
        'veui-option': Option
    },
    data() {
        return {
            isModalShow: false,
            isConfirmShow: false,
            loading: true,
            addLoading: false,
            unbandLoading: false,
            infoStatusMap: {
                2: {
                    text: '审核中',
                    color: '#faa90e'
                },
                4: {
                    text: '审核通过',
                    color: '#333'
                },
                6: {
                    text: '审核失败',
                    color: '#f95d5d'
                }
            },
            formData: {
                name: '',
                phone: ''
            },
            unbandUserInfo: {
                uk: '',
                name: '',
                avatar: ''
            },
            pn: 1,
            rn: 10,
            count: 0,
            tableData: [],
            businessId: 0,
            newLawyerName: '律所管理员',
            clueTransList: [],
            contentTransList: [],
            isLock: false, // 解绑锁
            isUnBind: true, // 是否可以直接解绑
            contentLawyerName: '',
            isHasClue: false, // 是否有线索
            isHasContent: false, // 是否有线索
            // 当前选择成员uk
            choicedUk: ''
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew
        })
    },
    watch: {
        userInfoNew: {
            deep: true,
            immediate: true,
            handler() {
                if (!this.userInfoNew?.law_business_info?.id) {
                    return;
                }
                this.businessId = this.userInfoNew?.law_business_info?.id;
                this.getData();
            }
        },
        isConfirmShow(next, pre) {
            if (next !== pre && !next) {
                this.loading = false;
            }
        }
    },
    methods: {
        getData(isAllList = false) {
            this.loading = true;
            const params = {
                businessId: this.businessId,
                show: '',
                pn: this.pn
            };
            if (!isAllList) {
                params.rn = this.rn;
            }
            this.$http.get(url.getBusinessMember, {
                params
            }).then(res => {
                const data = this.$normalizeResponseData(res);
                if (data) {
                    if (isAllList) {
                        let list = data.list || [];
                        list = list.filter(item => {
                            return item.uk !== this.choicedUk;
                        });
                        this.contentTransList = list;
                        this.clueTransList = [
                            {
                                name: '律所管理员'
                            },
                            ...list
                        ];
                        return;
                    }
                    this.tableData = data.list || [];
                    this.count = data.count || 0;
                }
                else {
                    this.contentTransList = [];
                    this.clueTransList = [];
                    this.tableData = [];
                    this.count = 0;
                }
                this.loading = false;
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.loading = false;
            });
        },
        // 添加律师
        addLawyer() {
            this.isModalShow = true;
        },
        // 添加律师-提交
        handleSubmitLawyer() {
            const {name, phone} = this.formData;
            this.$refs.form.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.addLoading = true;
                    this.$http.post(url.addBusinessMember, {
                        businessId: this.businessId,
                        name,
                        phone
                    }).then(res => {
                        if (+res.code === 0) {
                            this.$Message.success('当前律师已添加成功，需3小时后才能在【团队成员】中上线并展示于律所主页中');
                            this.handleModalClose();
                            this.getData();
                        }
                        else {
                            this.$Message.error(res.msg || '用户添加失败');
                        }
                        this.addLoading = false;
                    }).catch(err => {
                        this.$normalizeResponseError(err);
                        this.addLoading = false;
                    });
                }
                else {
                    this.$Message.error('有必填字段未填写，请完善后再提交');
                }
            });
        },
        // 关闭弹窗
        handleModalClose() {
            this.isModalShow = false;
            this.addLoading = false;
            this.formData.name = '';
            this.formData.phone = '';
        },
        // 解绑操作
        openUnbindConfirm(uk = '', name = '', avatar = '') {
            if (this.isLock) {
                return;
            }
            this.isLock = true;
            this.choicedUk = uk;
            // 获取换绑成员列表
            this.getData(true);
            this.$http.get(url.checkChangeMember, {
                params: {
                    businessId: this.businessId,
                    lawyerName: name
                }
            }).then(res => {
                let info = res?.data || {};
                this.isLock = false;
                this.isHasClue = info.hasClue;
                this.isHasContent = info.hasContent;
                // 换人跟进
                if (info && (info.hasClue || info.hasContent)) {
                    this.isUnBind = false;
                }
                else {
                    this.isUnBind = true;
                }
                this.unbandUserInfo = {
                    uk,
                    name,
                    avatar
                };
                this.newLawyerName = '律所管理员';
                this.contentLawyerName = '';
                this.isConfirmShow = true;
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.isLock = false;
            });
        },
        // 成员解绑
        hanldeUnband() {
            if (this.isHasContent && !this.contentLawyerName) {
                this.$Message.info('请先选择内容更换律师');
                return;
            }
            this.$http.post(url.delBusinessMember, {
                ...{
                    businessId: this.businessId,
                    uk: this.unbandUserInfo.uk,
                    name: this.unbandUserInfo.name,
                    // 不要乱动，后端逻辑混乱，目前需按照这个格式传，否则接口报错
                    strTargetName: this.newLawyerName || '',
                    // 内容转移
                    contentTargetName: this.isHasContent && this.contentLawyerName || '',
                    changeAll: 1
                }
            }).then(res => {
                if (+res.code === 0) {
                    this.$Message.success('解绑成功');
                    this.isConfirmShow = false;
                    // 重置
                    this.newLawyerName = '律所管理员';
                    this.contentLawyerName = '';
                    this.getData();
                }
                else {
                    this.$Message.error('解绑失败，请重新解绑');
                    this.openUnbindConfirm(this.unbandUserInfo.uk,
                                           this.unbandUserInfo.name, this.unbandUserInfo.avatar);
                }
                this.unbandLoading = false;
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.unbandLoading = false;
            });
        },
        // 确认解绑
        confirmUnband() {
            if (this.unbandLoading) {
                return;
            }
            this.unbandLoading = true;
            this.hanldeUnband();
        },
        pageChange(page) {
            this.pn = page;
            this.getData();
        },
        // 关闭换绑弹框
        hideConfirm() {
            this.isConfirmShow = false;
            this.loading = false;
        }
    }
};

</script>
<style lang="less" scoped>
@import "../../../assets/css/law-table.less";

.member-manage {
    padding: 0 30px 30px;
    border-radius: 8px;
    background: #fff;

    .page-title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 78px;
        padding: 19px 0;
        background: #fff;
        border-bottom: 1px solid #e9ecf3;
        box-sizing: border-box;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 18px;
            font-weight: 500;
            margin-top: 11px;
        }
    }

    .table-top {
        height: 88px;
        padding: 24px 0;
        text-align: right;
        box-sizing: border-box;

        .count {
            font-size: 16px;
            color: #333;
            line-height: 40px;
        }
    }

    .member-list-table {
        /deep/ .veui-table-cell-content {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .pagination {
        width: 100%;
        margin-top: 13px;
        justify-content: flex-end;

        /deep/ .veui-pagination-total {
            display: none;
        }
    }

    .avatar-name-cell {
        display: flex;
        align-items: center;

        .member-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }

        .member-name {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 6px;
            vertical-align: top;
        }
    }

    .blank {
        text-align: center;
        padding-bottom: 114px;

        .icon {
            height: 180px;
            width: 200px;
            background: url("../../../assets/img/law/no-data.png") no-repeat center center;
        }

        .text {
            margin-top: 12px;
            color: #333;
        }
    }
}

.add-lawyer-modal {
    /deep/ .veui-dialog-content {
        .tips {
            font-size: 13px;
            color: #848b99;
        }

        .veui-field-label {
            width: 8em;
            margin-right: 24px;
        }

        .veui-dialog-content-foot {
            text-align: center;
        }
    }
}

.unband-confirm {
    /deep/ .veui-input {
        height: 40px;
    }

    .confirm-text {
        height: 24px;
        line-height: 24px;
        color: #000;
    }

    .lawyer-box {
        display: flex;
        align-items: center;
        margin: 18px 0 12px;

        .lawyer-search {
            width: 224px;
        }
    }

    .confirm-tip {
        color: #999;
        line-height: 22px;
    }

    .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-item {
            border: 1px solid #3e4cff;
            border-radius: 5px;
            padding: 10px 29px;
            font-size: 14px;
            color: #3e4cff;
            cursor: pointer;
        }

        .confirm {
            background: #3e4cff;
            color: #fff;
            margin-left: 24px;

            &:hover {
                background: #2739d6;
            }
        }
    }
}
</style>
<style lang="less">
.unband-confirm {
    /deep/ [ui~="medium"] .veui-dialog-content {
        width: 600px !important;
    }
}
</style>